<template>
<div class="chapter">
<div class="inner_page">
<div style="width: 100%; height: 100%; margin: 0; padding: 0; text-align: center;"><img alt="Cover" id="CoverImage" src="CoverDesign.jpg" style="height: 100%; max-width: 100%; max-height: 100%; padding: 0; margin: 0;"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?498d1426